import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { APP_CONSTANT, AppConst } from 'src/app/core/_constants/app.constant';
import { showDuration } from 'src/app/core/_constants/helper';
import { ValidationService } from 'src/app/core/_services/common/validation.service';
import { PagesService } from 'src/app/core/_services/pages/pages.service';
import { OnlinePaymentComponent } from '../confirm-dialog/online-payment/online-payment.component';

@Component({
  selector: 'app-superadmin-modal',
  templateUrl: './superadmin-modal.component.html',
  styleUrls: ['./superadmin-modal.component.scss']
})
export class SuperadminModalComponent implements OnInit {

  validationErrorMessage = APP_CONSTANT.VALIDATION;
  maxLength = AppConst.MAXLENGTH;
  public submitForm: FormGroup;
  phoneNumber: any;
  submitted: boolean = false;
  durationArray = APP_CONSTANT.DURATION

  constructor(public dialogRef: MatDialogRef<OnlinePaymentComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, public validationService: ValidationService,
    private service: PagesService,
    private toastr: ToastrService,
    private loader: NgxUiLoaderService,) {
  }


  ngOnInit(): void {
    this.submitForm = this.createForm();
    if (this.data?.user) {
      this.patchData(this.data.user)
    }
  }

  patchData(data) {
    if(data.phoneNumber.includes('+1')){
      data.phoneNumber = data.phoneNumber.split('+1')[1];
    }
    this.submitForm.patchValue(data);
  }

  createForm() {
    return this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      // userName: [''],
      phoneNumber: ['', [Validators.required, Validators.min(0)]],
      email: ['', [Validators.required, Validators.pattern(AppConst.EMAIL_PATTERN)]],
      address: this.fb.group({
        addressLine1: ['', Validators.required],
        addressLine2: [''],
        city: ['', Validators.required],
        state: ['', Validators.required],
        country: ['', Validators.required],
        zipCode: ['', [Validators.required, Validators.pattern(AppConst.ZIPCODE_PATTERN)]],
        lat: [''],
        long: ['']
      }),
    })
  }

  addServiceAddress(edit?: boolean) {
    const control = this.submitForm.get('address') as FormArray;
    control.push(this.addressForm(edit));
  }
  addressForm(edit?: boolean) {
    console.log(edit)

    return (edit) ? this.fb.group({
      _id: [''],
      addressLine1: ['', Validators.required],
      addressLine2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', Validators.required],
      zipCode: ['', [Validators.required, Validators.pattern(AppConst.ZIPCODE_PATTERN)]],
      lat: [''],
      long: [''],
      isPrimary: [false],

    }) : this.fb.group({
      addressLine1: ['', Validators.required],
      addressLine2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', Validators.required],
      zipCode: ['', [Validators.required, Validators.pattern(AppConst.ZIPCODE_PATTERN)]],
      lat: [''],
      long: [''],
      isPrimary: [false]
    })

  }
  getAddress(form) {
    return form.controls.serviceAddress.controls;
  }

  get f() { return this.submitForm.controls; }


  close(value: Boolean) {
    this.dialogRef.close(value);
  }

  selectedAddress: string = '';
  selectedAddressText: string[] = [];

  handleAddressChange(address: any, type: number, index?: number) {
    let control: any;
    control = this.submitForm.get('address')
    // Clear existing values
    control.patchValue({
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      country: '',
      zipCode: '',
      lat: '',
      long: ''
    });

    const addressLine1: string[] = [];
    const addressLine2: string[] = [];
    const zipParts: string[] = [];

    if (!address?.addressComponents) return;

    for (const component of address.addressComponents) {
      const types = component.types;

      if (types.includes('street_number')) {
        addressLine1.unshift(component.longText);
      }

      if (types.includes('route')) {
        addressLine1.push(component.longText);
      }

      if (types.includes('neighborhood') || types.includes('sublocality_level_1')) {
        addressLine2.push(component.longText);
      }

      if (types.includes('locality')) {
        control.patchValue({ city: component.longText });
      }

      if (types.includes('administrative_area_level_1')) {
        control.patchValue({ state: component.longText });
      }

      if (types.includes('country')) {
        control.patchValue({ country: component.longText });
      }

      if (types.includes('postal_code')) {
        zipParts.push(component.longText);
      }

      if (types.includes('postal_code_suffix')) {
        zipParts.push(component.longText);
      }
    }


    control.patchValue({
      addressLine1: addressLine1.join(' '),
      addressLine2: addressLine2.join(', '),
      zipCode: zipParts.join('-'),
      lat: address.location?.lat ?? '',
      long: address.location?.lng ?? ''
    });

    // Clear search input after selection
    this.selectedAddress = address.formattedAddress;
    this.AddressSearch = '';
  }
  AddressSearch: any;

  get businessControl() {
    return this.submitForm.controls['address']['controls'];
  }

  addPackage(block?: boolean) {
    this.submitted = true;
    if (this.submitForm.valid || block) {
      let payload = {};
      payload = this.submitForm.value;
      if (block) {
        payload['status'] = this.data.user.status == 'Active' ? 'Inactive' : 'Active';
      } else {
        payload['status'] = 'Active'
      }
      if (this.data?.user) {
        payload['_id'] = this.data.user._id;
      }
      if (payload['phoneNumber'] && !payload['phoneNumber'].includes('+1')) {
        payload['phoneNumber'] = '+1' + payload['phoneNumber']
      }
      this.loader.start();
      this.service.post(payload, `${API_ROUTES.ACCOUNT.inviteSuperAdmin}`).subscribe({
        next: (res: any) => {
          if (res.status) {
            this.loader.stop();
            this.toastr.success(res.msg);
            setTimeout(() => {
              this.dialogRef.close(true);
            }, 500)
          } else {
            this.loader.stop();
            this.toastr.error(res);
          }
        },
        error: (err: any) => {
          this.loader.stop();
          this.toastr.error(err.msg);
        },
        complete: () => this.loader.stop()
      })
    }
  }
}
